import React from 'react';
import Navbar from './Navbar';
import ErrorResponseHandler from './ErrorResponseHandler';
import style from './AppContainer.scss';
var AppContainer = function (_a) {
    var Component = _a.component, render = _a.render;
    return React.createElement("div", { className: style['app-container'] },
        React.createElement(ErrorResponseHandler, null),
        React.createElement(Navbar, null),
        React.createElement("div", { className: style['section-container'] }, render ? render() : React.createElement(Component, null)));
};
export default AppContainer;
